(function () {

	"use strict";

	angular
		.module("vertica.scroll", [])
		.service("scroll", scroll);

	scroll.$inject = [
		"$window",
		"$q",
		"animation"
	];

	function scroll($window, $q, animation) {

		var timer = function (fn, duration) {

				var deferred = $q.defer(),
					start = +new Date(),
					end = start + duration,
					current = start,
					lastPercent = 0,
					step = function () {

						current = +new Date();
						lastPercent = (current - start) / duration;

						fn(lastPercent = 1 > lastPercent ? lastPercent : 1);

						if (current > end) {
							deferred.resolve();
						} else {
							animation.rAF(step);
						}
					};

				animation.rAF(step);

				return deferred.promise;
			};

		return function (destination, duration) {

			var defer = $q.defer(),
			    isLeftDefined = angular.isDefined(destination.left),
			    isTopDefined = angular.isDefined(destination.top),
				reject = !angular.isObject(destination) || (!isLeftDefined && !isTopDefined) || (isLeftDefined && !angular.isNumber(destination.left)) || (isTopDefined && !angular.isNumber(destination.top));

			defer[reject ? "reject": "resolve"]();

			if (reject)
			{
				return defer.promise;
			}

			var left = destination.left || 0,
			    top = destination.top || 0,
			    startLeft = $window.pageXOffset,
			    startTop = $window.pageYOffset,
				fn = function (i) {
				    $window.scrollTo(startLeft * (1 - i) + left * i, startTop * (1 - i) + top * i);
			    };

			if (startTop === top && startLeft === left)
			{
				return defer.promise;
			}

	   		return timer(fn, null == duration ? 175 : duration);
		};

	}

})();